// global modal - there should only ever be one of these open at once
// if child modals are needed, those can be added at that level
import Modal from "@mui/material/Modal";
import React, { ReactElement,ReactNode  } from "react";
import { useStoreDispatch, useStoreSelector } from "../../../store/Hooks";
import { navSliceActions } from "../../../store/slices/NavSlice";
import Box from "@mui/material/Box";

interface CareSenseModalProps {
  children: ReactNode;
}

const CareSenseModal = (props: CareSenseModalProps) => {
  const dispatch = useStoreDispatch();
  const caresenseModalOpen = useStoreSelector(
    (state) => state.nav.caresenseModalOpen,
  );
  const handleClose = () => {
    dispatch(
      navSliceActions.closeModal(),
    );
  };
  return (
    <div>
      <Modal
        // style = {{border:"10pt solid #1976d2"}}
        open={caresenseModalOpen}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box>{props.children}</Box>
      </Modal>
    </div>
  );
};

export default CareSenseModal;
